import { RequireStaff } from "@/components/RequireStaff";
import { CalendarView } from "@/components/calendar";

export default function StaffCalendar() {
  return (
    <RequireStaff>
      <CalendarView />
    </RequireStaff>
  );
}
